﻿import { Component, Inject, Input, Output } from "@fiqas/angular-utils";
import { IRoutingComponent, RouteConfig } from "@fiqas/ngcomponentrouter";
import { FIQAssist } from "../app";
import { Application } from "./application"
import { StartResult } from "../models/home"
import { HomeService } from "../services/fiqassistApi/homeService";
import { AuthenticationService } from "../services/authenticationService";
import { TranslationService } from "../services/TranslationService";
import * as hotkeys from 'angular-hotkeys';
import { AuthorizationService } from "../services/authorizationService";

@Component({
    module: FIQAssist,
    selector: "home",
    templateUrl: "views/home.html",
    require: {
        "application": "^application"
    }
})
@RouteConfig([
    { path: '/search', name: "Search", component: "search" },
    { path: '/project', name: "Project", component: "projectTab" },
    { path: '/**', name: "SimpleSearch", component: "searchTab", useAsDefault: true }
]
)
export class Home implements IRoutingComponent {
    public active1: boolean;
    public active2: boolean;
    public activeMenuItem = "home";
    public fullMenu: boolean = false;
    public dividerTooltip: string;

    private _startResult: StartResult;
    public application: Application;

    private hotkey: ng.hotkeys.Hotkey[];
    private tabsHotkeys: ng.hotkeys.Hotkey;

    @Input() $router: ng.Router;

    constructor(
        @Inject() private authenticationService: AuthenticationService,
        @Inject() private authorizationService: AuthorizationService,
        @Inject() private homeService: HomeService,
        @Inject() private translationService: TranslationService,
        @Inject('$scope') $scope: ng.IScope,
        @Inject('$location') private $location: ng.ILocationService,
        @Inject('hotkeys') private hotkeys: ng.hotkeys.HotkeysProvider
    ) {
        hotkeys.bindTo($scope);
        this.hotkey = [this.tabsHotkeys = {
            combo: ['alt+1'],
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: (e) => {
                this.$router.navigate(['Home', 'SimpleSearch']);
            }
        }, {
            combo: ['alt+2'],
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: (e) => {
                this.$router.navigate(['Home', 'ProjectSearch']);
            },
        }, {
            combo: ['alt+3'],
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: (e) => {
                this.$router.navigate(['Home', 'Search']);
            },
        }
        ];
    }

    public async $routerOnActivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
        this.fullMenu = !!next.params['menu'];
        if (next['routeName'] == 'Default') {
            this.$router.navigate(['Home', 'SimpleSearch', next.params]);
        } else if (this.$location.search()['referer'] == 'projectSearch') {
            this.$router.navigate(['Home', 'ProjectSearch', next.params]);
        } else if (this.$location.search()['referer'] == 'search') {
            this.$router.navigate(['Home', 'Search', next.params]);
        }
    }

    public async $routerOnReuse(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
    }

    public get activeTab() {
        var current = this.$location.url();
        switch (current.substring(current.lastIndexOf('/'))) {
            case "/project":
                return 1;
            case "/search": // extended-search
                return 2;
            default: // home/compact-search
                return 0;
        }
    }

    $onInit() {
        this.dividerTooltip = this.translationService.Translate(this.fullMenu ? "COLLAPSE_TOOLTIP" : "EXPAND_TOOLTIP");

        this.hotkey.forEach(key => {
            this.hotkeys.add(key);
        });
    }


    $onDestroy() {
        this.hotkey.forEach(key => {
            this.hotkeys.del(key.combo);
        });
    }

    public onFullMenuToggle(): void {
        this.fullMenu = !this.fullMenu;
        this.dividerTooltip = this.translationService.Translate(this.fullMenu ? "COLLAPSE_TOOLTIP" : "EXPAND_TOOLTIP");
    }

    public onFullMenuKey(event: KeyboardEvent): void {
        switch (event.keyCode) {
            case 13:
            case 32:
                event.preventDefault();
                this.fullMenu = !this.fullMenu;
                break;
        }
    }

    private tabfocused: boolean = false;

    public tabFocus() {
        this.tabfocused = true;
    }
    public tabBlur() {
        this.tabfocused = false;
    }
}
